var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCyberSecurity = function SvgCyberSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.674 6.761C33.839 6.5 28.264 4.401 23.802.8a3.714 3.714 0 0 0-4.604 0C14.736 4.402 9.16 6.499 3.332 6.76 1.457 6.888 0 8.378 0 10.177v6.967c0 19.199 15.212 28.187 19.89 30.48 1.019.501 2.223.501 3.241 0C27.789 45.332 43 36.344 43 17.145v-6.967c0-1.799-1.452-3.29-3.326-3.416m-6.247 13.39L19.097 32.15a1.86 1.86 0 0 1-2.45-.081l-5.374-5.144a1.66 1.66 0 0 1 .026-2.4 1.85 1.85 0 0 1 2.508-.025l4.187 4.012 13.079-10.949a1.844 1.844 0 0 1 2.518.172c.65.707.576 1.789-.164 2.415"
  })));
};
export default SvgCyberSecurity;